var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils, Watch, PropertyConverters } from './_default-imports';
import { CustomElementUtils } from '../../utils-customelement';
import { PacemItemElement, PacemItemsContainerElement } from './items-container';
//namespace Pacem.Components {
export class PacemIterableElement extends PacemItemElement {
    /** @overrides */
    findContainer() {
        return CustomElementUtils.findAncestor(this, n => n instanceof PacemIterativeElement);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        const iter = this.container;
        const index = (iter && iter.items || []).indexOf(this);
        index >= 0
            && iter
            && iter.adapter
            && iter.adapter.itemPropertyChangedCallback(index, name, old, val, first);
    }
}
export class PacemIterativeElement extends PacemItemsContainerElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        // notify the adapter, if any.
        this.adapter && this.adapter.masterPropertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'adapter':
                if (!Utils.isNull(old)) {
                    old.destroy();
                }
                if (!Utils.isNull(val)) {
                    this.adapter.initialize(this);
                }
                break;
            case 'items':
                if (this.isReady /* connected and DOM-ready */) {
                    this._checkIndex();
                }
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._checkIndex();
    }
    _checkIndex() {
        let ndx = 0;
        if (!Utils.isNullOrEmpty(this.items)) {
            if (this.index < this.items.length) {
                ndx = this.index;
            }
        }
        this.index = ndx;
    }
    disconnectedCallback() {
        if (!Utils.isNull(this.adapter))
            this.adapter.destroy();
        super.disconnectedCallback();
    }
}
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemIterativeElement.prototype, "adapter", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemIterativeElement.prototype, "index", void 0);
//}
